import React, { Fragment } from "react";
import Collapsible from "react-collapsible";
import { FlexBox } from "~/components/.base/containers";
import { Subheading, BodyText, BodyTextAlt } from "~/components/.base/headings";
import ClockIcon from "~/images/icons/location_clock.svg";

const TruckScheduleMobile = ({
	scheduleData,
	formatTitle,
	formatTime,
	formatDateMini,
	formatAddress,
	weekDates,
}) => {
	return (
		<div className="mobile-schedule">
			{scheduleData ? (
				<Fragment>
					{scheduleData["Sunday"] ? (
						<Collapsible
							open={true}
							trigger={`Sun, ${formatDateMini(weekDates[0])}`}
						>
							{scheduleData["Sunday"].map((event, i) => (
								<div key={i} className="schedule-item">
									<Subheading>
										{formatTitle(event.summary)}
									</Subheading>
									{event.isWithinDistance ? (
										<div class="within-distance">
											Within Range
										</div>
									) : null}
									<FlexBox className="time" align="center">
										<ClockIcon />
										<BodyTextAlt>
											{formatTime(event.start, event.end)}
										</BodyTextAlt>
									</FlexBox>
									<a
										href={`https://maps.google.com/?q=${formatAddress(
											event.formattedAddress,
											event.location
										)}`}
										target="_/blank"
									>
										<BodyText>
											{formatAddress(
												event.formattedAddress,
												event.location
											)}
										</BodyText>
									</a>
								</div>
							))}
						</Collapsible>
					) : null}
					{scheduleData["Monday"] ? (
						<Collapsible
							open={true}
							trigger={`Mon, ${formatDateMini(weekDates[1])}`}
						>
							{scheduleData["Monday"].map((event, i) => (
								<div key={i} className="schedule-item">
									<Subheading>
										{formatTitle(event.summary)}
									</Subheading>
									{event.isWithinDistance ? (
										<div class="within-distance">
											Within Range
										</div>
									) : null}
									<FlexBox className="time" align="center">
										<ClockIcon />
										<BodyTextAlt>
											{formatTime(event.start, event.end)}
										</BodyTextAlt>
									</FlexBox>
									<a
										href={`https://maps.google.com/?q=${formatAddress(
											event.formattedAddress,
											event.location
										)}`}
										target="_/blank"
									>
										<BodyText>
											{formatAddress(
												event.formattedAddress,
												event.location
											)}
										</BodyText>
									</a>
								</div>
							))}
						</Collapsible>
					) : null}
					{scheduleData["Tuesday"] ? (
						<Collapsible
							open={true}
							trigger={`Tue, ${formatDateMini(weekDates[2])}`}
						>
							{scheduleData["Tuesday"].map((event, i) => (
								<div key={i} className="schedule-item">
									<Subheading>
										{formatTitle(event.summary)}
									</Subheading>
									{event.isWithinDistance ? (
										<div class="within-distance">
											Within Range
										</div>
									) : null}
									<FlexBox className="time" align="center">
										<ClockIcon />
										<BodyTextAlt>
											{formatTime(event.start, event.end)}
										</BodyTextAlt>
									</FlexBox>
									<a
										href={`https://maps.google.com/?q=${formatAddress(
											event.formattedAddress,
											event.location
										)}`}
										target="_/blank"
									>
										<BodyText>
											{formatAddress(
												event.formattedAddress,
												event.location
											)}
										</BodyText>
									</a>
								</div>
							))}
						</Collapsible>
					) : null}
					{scheduleData["Wednesday"] ? (
						<Collapsible
							open={true}
							trigger={`Wed, ${formatDateMini(weekDates[3])}`}
						>
							{scheduleData["Wednesday"].map((event, i) => (
								<div key={i} className="schedule-item">
									<Subheading>
										{formatTitle(event.summary)}
									</Subheading>
									{event.isWithinDistance ? (
										<div class="within-distance">
											Within Range
										</div>
									) : null}
									<FlexBox className="time" align="center">
										<ClockIcon />
										<BodyTextAlt>
											{formatTime(event.start, event.end)}
										</BodyTextAlt>
									</FlexBox>
									<a
										href={`https://maps.google.com/?q=${formatAddress(
											event.formattedAddress,
											event.location
										)}`}
										target="_/blank"
									>
										<BodyText>
											{formatAddress(
												event.formattedAddress,
												event.location
											)}
										</BodyText>
									</a>
								</div>
							))}
						</Collapsible>
					) : null}
					{scheduleData["Thursday"] ? (
						<Collapsible
							open={true}
							trigger={`Thu, ${formatDateMini(weekDates[4])}`}
						>
							{scheduleData["Thursday"].map((event, i) => (
								<div key={i} className="schedule-item">
									<Subheading>
										{formatTitle(event.summary)}
									</Subheading>
									{event.isWithinDistance ? (
										<div class="within-distance">
											Within Range
										</div>
									) : null}
									<FlexBox className="time" align="center">
										<ClockIcon />
										<BodyTextAlt>
											{formatTime(event.start, event.end)}
										</BodyTextAlt>
									</FlexBox>
									<a
										href={`https://maps.google.com/?q=${formatAddress(
											event.formattedAddress,
											event.location
										)}`}
										target="_/blank"
									>
										<BodyText>
											{formatAddress(
												event.formattedAddress,
												event.location
											)}
										</BodyText>
									</a>
								</div>
							))}
						</Collapsible>
					) : null}
					{scheduleData["Friday"] ? (
						<Collapsible
							open={true}
							trigger={`Fri, ${formatDateMini(
								weekDates[5],
								true
							)}`}
						>
							{scheduleData["Friday"].map((event, i) => (
								<div key={i} className="schedule-item">
									<Subheading>
										{formatTitle(event.summary)}
									</Subheading>
									{event.isWithinDistance ? (
										<div class="within-distance">
											Within Range
										</div>
									) : null}
									<FlexBox className="time">
										<ClockIcon />
										<BodyTextAlt>
											{formatTime(event.start, event.end)}
										</BodyTextAlt>
									</FlexBox>
									<a
										href={`https://maps.google.com/?q=${formatAddress(
											event.formattedAddress,
											event.location
										)}`}
										target="_/blank"
									>
										<BodyText>
											{formatAddress(
												event.formattedAddress,
												event.location
											)}
										</BodyText>
									</a>
								</div>
							))}
						</Collapsible>
					) : null}
					{scheduleData["Saturday"] ? (
						<Collapsible
							open={true}
							trigger={`Sat, ${formatDateMini(weekDates[6])}`}
						>
							{scheduleData["Saturday"].map((event, i) => (
								<div key={i} className="schedule-item">
									<Subheading>
										{formatTitle(event.summary)}
									</Subheading>
									{event.isWithinDistance ? (
										<div class="within-distance">
											Within Range
										</div>
									) : null}
									<FlexBox className="time" align="center">
										<ClockIcon />
										<BodyTextAlt>
											{formatTime(event.start, event.end)}
										</BodyTextAlt>
									</FlexBox>
									<a
										href={`https://maps.google.com/?q=${formatAddress(
											event.formattedAddress,
											event.location
										)}`}
										target="_/blank"
									>
										<BodyText>
											{formatAddress(
												event.formattedAddress,
												event.location
											)}
										</BodyText>
									</a>
								</div>
							))}
						</Collapsible>
					) : null}
				</Fragment>
			) : null}
		</div>
	);
};

export default TruckScheduleMobile;
